<template>
  <div v-if="releases.length" class="space-y-3">
    <DashboardRosUpdate
      v-for="(release, index) in releases"
      :key="releaseKey(release)"
      :release="release"
      :is-new="index === 0"
    />
  </div>
</template>

<script lang="ts" setup>
import { getRecentRosDashboardReleases } from '@/data/ros-dashboard-releases';
import type { RosDashboardRelease } from '@/entities/ros-updates/ros-update.entity';
import DashboardRosUpdate from './DashboardRosUpdate.vue';

const releases = getRecentRosDashboardReleases(3);

function releaseKey(release: RosDashboardRelease) {
  return `${release.releasedAt}-${release.commitSha}`;
}
</script>
